import List from './list'
import New from './new'
import Edit from './edit'
export default { List, New, Edit }
